import { config } from '@lingoda/config';

export const isSentryTrackingEnabled = () => !!config.sentryFrontendDsn;
